/* Momuna · Pagos (20-10-2026): "Pagar online" sin duplicados, "Pagar en casa" (Releasit COD Form), la bolsita flotante
   y detalles de accesibilidad de las hojas. No toca momuna-ficha.js: lee el pack elegido del radio marcado (o de ?variant=)
   y la cantidad de la hoja.
   - [data-comprar] / [data-hoja-comprar] (Pagar online): se adelanta al handler de momuna-ficha.js (captura) y solo agrega
     lo que falta en la bolsa antes de ir al checkout, así tocar dos veces o haber usado la bolsita no duplica unidades.
   - [data-casa]: copia variante y cantidad al formulario oculto [data-cod-form] y aprieta el botón que Releasit dibuja
     adentro de #rsi-button-hook. Si Releasit no cargó en 3 s, ofrece WhatsApp o pagar online.
   - [data-agregar] / [data-hoja-agregar]: el agregado lo hace momuna-ficha.js; acá va la fiesta: la foto vuela a la bolsa
     del header, la bolsita rebota, muestra el tilde y el contador real (/cart.js).
   - Hojas (compra y transferencia): el foco queda adentro con Tab y vuelve al botón que las abrió al cerrar.
   - [data-anuncio]: le cuenta al lector de pantalla el pack elegido y su precio.
   Eventos: window 'momuna:casa' y 'momuna:compra' (y Shopify.analytics.publish si existe). */
(function () {
  'use strict';
  var W = window, d = document;

  function plata(c) {
    c = Math.round(c);
    var p = Math.floor(c / 100), dec = c % 100;
    return '$' + String(p).replace(/\B(?=(\d{3})+(?!\d))/g, '.') + (dec ? ',' + String(dec).padStart(2, '0') : '');
  }
  function reducido() { return W.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches; }
  function publicar(nombre, datos) {
    try { W.dispatchEvent(new CustomEvent(nombre, { detail: datos })); } catch (e) {}
    try { if (W.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(nombre.replace(':', '_'), datos); } catch (e) {}
  }
  function raizRutas() { return (W.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  function pedir(url, cuerpo) {
    var op = { headers: { Accept: 'application/json' } };
    if (cuerpo) { op.method = 'POST'; op.headers['Content-Type'] = 'application/json'; op.body = JSON.stringify(cuerpo); }
    return fetch(url, op).then(function (r) { if (!r.ok) throw r; return r.json(); });
  }

  function Pagos(raiz) {
    var packs = [];
    try { packs = JSON.parse(raiz.querySelector('[data-mm-packs]').textContent); } catch (e) {}
    var porId = {}; packs.forEach(function (p) { porId[p.id] = p; });
    var root = raizRutas();

    /* pack elegido: radio marcado → ?variant= → el primero */
    function elegida() {
      var r = raiz.querySelector('[data-pack-radio]:checked');
      if (r && porId[r.value]) return porId[r.value];
      try { var v = new URL(location.href).searchParams.get('variant'); if (v && porId[v]) return porId[v]; } catch (e) {}
      return packs[0] || null;
    }
    function cantidadHoja() {
      var o = raiz.querySelector('[data-hoja-cant]'), n = o ? parseInt(o.textContent, 10) : 1;
      return n > 0 && n <= 20 ? n : 1;
    }
    var aviso = raiz.querySelector('[data-aviso]'), avisoT;
    function avisar(html, ms) {
      if (!aviso) return;
      aviso.innerHTML = html; aviso.classList.add('is-on');
      clearTimeout(avisoT); avisoT = setTimeout(function () { aviso.classList.remove('is-on'); }, ms || 6000);
    }

    /* ---- Pagar online: solo agrega lo que falta y va al checkout ---- */
    function pagarOnline(b, e) {
      e.stopImmediatePropagation(); e.preventDefault();
      if (b.classList.contains('is-cargando')) return;
      var p = elegida(); if (!p) return;
      var enHoja = !!b.closest('[data-hoja]'), n = enHoja ? cantidadHoja() : 1;
      b.classList.add('is-cargando');
      publicar('momuna:compra', { variante: p.id, pack: p.n, cantidad: n, precio: p.precio / 100, origen: enHoja ? 'hoja' : (b.getAttribute('data-origen') || '') });
      pedir(root + 'cart.js').catch(function () { return { items: [] }; }).then(function (c) {
        var tiene = 0;
        (c.items || []).forEach(function (i) { if (String(i.variant_id) === String(p.id)) tiene += i.quantity; });
        if (tiene >= n) return null;
        return pedir(root + 'cart/add.js', { items: [{ id: p.id, quantity: n - tiene }] });
      }).then(function () {
        location.href = root + 'checkout';
      }).catch(function () {
        b.classList.remove('is-cargando');
        avisar('No pudimos agregarlo. Probá de nuevo en un ratito.');
      });
    }
    raiz.querySelectorAll('[data-comprar], [data-hoja-comprar]').forEach(function (b) {
      b.addEventListener('click', function (e) { pagarOnline(b, e); }, true);
    });

    /* ---- Pagar en casa (Releasit) ---- */
    var cod = raiz.querySelector('[data-cod-form]');
    function botonReleasit() {
      return d.querySelector('#rsi_buy_now_button') || (cod ? cod.querySelector('button') : null);
    }
    function casa(b) {
      var p = elegida(); if (!p) return;
      var n = b.closest('[data-hoja]') ? cantidadHoja() : 1;
      if (cod) {
        var id = cod.querySelector('[data-cod-id]'), q = cod.querySelector('[data-cod-qty]');
        if (id) id.value = p.id;
        if (q) q.value = n;
      }
      publicar('momuna:casa', { variante: p.id, pack: p.n, cantidad: n, precio: p.precio / 100, origen: b.getAttribute('data-origen') || '' });
      var t0 = Date.now();
      b.classList.add('is-cargando');
      (function intentar() {
        var r = botonReleasit();
        if (r) { b.classList.remove('is-cargando'); r.click(); return; }
        if (Date.now() - t0 < 3000) { setTimeout(intentar, 120); return; }
        b.classList.remove('is-cargando');
        var wa = raiz.getAttribute('data-wa') || '', nombre = raiz.getAttribute('data-producto') || '';
        var msj = 'Hola Momuna 👋 Quiero pagar en casa: ' + nombre + ' (' + p.titulo + (n > 1 ? ' × ' + n : '') + ').';
        avisar('El pago en casa no cargó.' + (wa ? ' <a href="https://wa.me/' + wa + '?text=' + encodeURIComponent(msj) + '" target="_blank" rel="noopener">Pedilo por WhatsApp</a>' : '') + '<a href="#" data-ir-online>Pagar online</a>', 9000);
        var alt = aviso && aviso.querySelector('[data-ir-online]');
        if (alt) alt.addEventListener('click', function (e) {
          e.preventDefault();
          var pri = raiz.querySelector('[data-hoja]:not([hidden]) [data-hoja-comprar]') || raiz.querySelector('[data-boton-principal]');
          if (pri) pri.click();
        });
      })();
    }
    raiz.querySelectorAll('[data-casa]').forEach(function (b) { b.addEventListener('click', function () { casa(b); }); });

    /* ---- Bolsita: la fiesta al agregar ---- */
    var bolsita = raiz.querySelector('[data-bolsita]');
    function destino() { return d.querySelector('#header-component [data-testid="cart-drawer-trigger"], #header-component cart-icon, #header-component [href*="/cart"]'); }
    function volar(desde) {
      if (reducido()) return;
      var foto = raiz.querySelector('.mm-f__slide img'), meta = destino();
      if (!foto || !meta || !(foto.currentSrc || foto.src)) return;
      var a = desde.getBoundingClientRect(), z = meta.getBoundingClientRect();
      var im = d.createElement('img'); im.className = 'mm-vuelo'; im.src = foto.currentSrc || foto.src; im.alt = '';
      im.style.left = (a.left + a.width / 2 - 28) + 'px'; im.style.top = (a.top + a.height / 2 - 28) + 'px';
      if (!im.animate) return;
      d.body.appendChild(im);
      var dx = (z.left + z.width / 2) - (a.left + a.width / 2), dy = (z.top + z.height / 2) - (a.top + a.height / 2);
      im.animate([
        { transform: 'translate(0,0) scale(1)', opacity: 1 },
        { transform: 'translate(' + (dx * .5) + 'px,' + (dy * .5 - 80) + 'px) scale(.8)', opacity: 1, offset: .5 },
        { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(.2)', opacity: .4 }
      ], { duration: 720, easing: 'cubic-bezier(.3,.7,.3,1)', fill: 'forwards' }).onfinish = function () {
        im.remove();
        meta.classList.add('mm-meta-rebote'); setTimeout(function () { meta.classList.remove('mm-meta-rebote'); }, 600);
      };
    }
    function contar() {
      if (!bolsita) return;
      pedir(root + 'cart.js').then(function (c) {
        var n = bolsita.querySelector('[data-bolsita-n]'); if (!c || !n) return;
        n.textContent = c.item_count; n.hidden = !(c.item_count > 0);
      }).catch(function () {});
    }
    function festejar(btn) {
      var objetivo = btn.classList.contains('mm-bolsita') ? btn : bolsita;
      volar(btn);
      if (objetivo) { objetivo.classList.remove('is-rebote'); void objetivo.offsetWidth; objetivo.classList.add('is-rebote'); }
      if (navigator.vibrate) { try { navigator.vibrate(12); } catch (e) {} }
      setTimeout(function () {
        if (aviso && /No pudimos/.test(aviso.textContent)) return; /* falló el agregado: nada que festejar */
        [bolsita, objetivo].forEach(function (el) { if (el) el.classList.add('is-ok'); });
        contar();
        setTimeout(function () { [bolsita, objetivo].forEach(function (el) { if (el) el.classList.remove('is-ok'); }); }, 1800);
      }, 700);
    }
    raiz.querySelectorAll('[data-agregar], [data-hoja-agregar]').forEach(function (b) {
      b.addEventListener('click', function () { festejar(b); });
    });
    if (bolsita) {
      setTimeout(contar, 1500);
      /* saludo inicial: un meneo y el globito "Agregar a la bolsa" por 2,5 s (una vez por visita) */
      var ya = false; try { ya = sessionStorage.getItem('mm-bolsita') === '1'; } catch (e) {}
      if (!ya) setTimeout(function () {
        bolsita.classList.add('is-saludo', 'is-globo');
        setTimeout(function () { bolsita.classList.remove('is-saludo', 'is-globo'); }, 2600);
        try { sessionStorage.setItem('mm-bolsita', '1'); } catch (e) {}
      }, 2200);
    }

    /* ---- Hojas: foco adentro mientras están abiertas y de vuelta al abrirlas ---- */
    function foco(selHoja, selAbre) {
      var caja = raiz.querySelector(selHoja); if (!caja) return;
      var abridor = null;
      raiz.querySelectorAll(selAbre).forEach(function (b) { b.addEventListener('click', function () { abridor = b; }); });
      if ('MutationObserver' in W) new MutationObserver(function () {
        if (caja.hidden && abridor) { try { abridor.focus({ preventScroll: true }); } catch (e) {} abridor = null; }
      }).observe(caja, { attributes: true, attributeFilter: ['hidden'] });
      caja.addEventListener('keydown', function (e) {
        if (e.key !== 'Tab') return;
        var f = Array.prototype.filter.call(caja.querySelectorAll('button:not([disabled]), a[href], input:not([disabled]), [tabindex="0"]'), function (el) { return el.offsetParent !== null; });
        if (!f.length) return;
        var a = f[0], z = f[f.length - 1];
        if (e.shiftKey && d.activeElement === a) { z.focus(); e.preventDefault(); }
        else if (!e.shiftKey && d.activeElement === z) { a.focus(); e.preventDefault(); }
      });
    }
    foco('[data-hoja]', '[data-hoja-abrir]');
    foco('[data-tr]', '[data-transfer]');

    /* ---- Lector de pantalla: qué pack quedó elegido ---- */
    var anuncio = raiz.querySelector('[data-anuncio]');
    if (anuncio) W.addEventListener('momuna:pack', function (e) {
      var p = e.detail && porId[e.detail.variante]; if (!p) return;
      anuncio.textContent = 'Pack de ' + p.titulo + ': ' + plata(p.precio) + (raiz.getAttribute('data-sin-recargo') === 'true' ? ', ' + (raiz.getAttribute('data-cuotas') || 12) + ' cuotas de ' + plata(p.cuota) : '');
    });
  }

  function iniciar() { d.querySelectorAll('[data-mm-ficha]').forEach(function (r) { if (!r._mmPagos) { r._mmPagos = 1; Pagos(r); } }); }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', iniciar); else iniciar();
  d.addEventListener('shopify:section:load', iniciar);
})();
